export type { IDescendantsVariantContext } from './descendants-variant-context';

export { DescendantsVariantContext } from './descendants-variant-context';
